import { render, staticRenderFns } from "./Cloze.vue?vue&type=template&id=62cf0e7f&scoped=true&"
import script from "./Cloze.vue?vue&type=script&lang=js&"
export * from "./Cloze.vue?vue&type=script&lang=js&"
import style0 from "./Cloze.vue?vue&type=style&index=0&id=62cf0e7f&scoped=true&lang=less&"
import style1 from "./Cloze.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cf0e7f",
  null
  
)

export default component.exports